import { AD, ADVERTISEMENT, HIGHLIGHT, MOVIE, WEISCHER } from '../../constants/itemTypes'
import ListItemDataAdContainer from '../../components/DragAndDropItems/cont/ListItemDataAdContainer'
import ListItemDataWeischerContainer from '../../components/DragAndDropItems/cont/ListItemDataWeischerContainer'
import ListItemDataAdvertisementContainer from '../../components/DragAndDropItems/cont/ListItemDataAdvertisementContainer'
import ListItemDataMovieContainer from '../../components/DragAndDropItems/cont/ListItemDataMovieContainer'
import ListItemDataHighlightContainer from '../../components/DragAndDropItems/cont/ListItemDataHighlightContainer'

const ItemContainer = ({
    id, 
    type, 
    pathnameEdit,
    removeItemFromCollection
}) => {
    if(AD === type) {
        return <ListItemDataAdContainer
            itemId={id}
            pathnameEdit={pathnameEdit}
            onDeleteItem={removeItemFromCollection}
        />
    } else if (HIGHLIGHT === type) {
        return <ListItemDataHighlightContainer
            itemId={id}
            pathnameEdit={pathnameEdit}
            onDeleteItem={removeItemFromCollection}
        />
    } else if (WEISCHER === type) {
        return <ListItemDataWeischerContainer
            itemId={id}
            pathnameEdit={pathnameEdit}
            onDeleteItem={removeItemFromCollection}
        />
    } else if(MOVIE === type) {
        return <ListItemDataMovieContainer
            itemId={id}
            pathnameEdit={pathnameEdit}
            onDeleteItem={removeItemFromCollection}
        />
    } else if(ADVERTISEMENT === type) {
        return <ListItemDataAdvertisementContainer
            itemId={id}
            pathnameEdit={pathnameEdit}
            onDeleteItem={removeItemFromCollection}
        />
    } else {
        return ''
    }
}

export default ItemContainer